var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.66602C6.31814 1.66602 3.33337 5.0015 3.33337 8.74935C3.33337 12.4678 5.46114 16.5097 8.78093 18.0614C9.55483 18.4231 10.4453 18.4231 11.2192 18.0614C14.5389 16.5097 16.6667 12.4678 16.6667 8.74935C16.6667 5.0015 13.6819 1.66602 10 1.66602ZM10 9.99935C10.9205 9.99935 11.6667 9.25316 11.6667 8.33268C11.6667 7.41221 10.9205 6.66602 10 6.66602C9.07957 6.66602 8.33337 7.41221 8.33337 8.33268C8.33337 9.25316 9.07957 9.99935 10 9.99935Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon4);
export default __webpack_public_path__ + "static/media/location-icon-4.97306876527718549a440ecc3051899e.svg";
export { ForwardRef as ReactComponent };